var ctrl = function($scope, svelteComponent, svelteProps, appContainerContentClass) {
  $scope.svelteComponentConstructor = svelteComponent;
  $scope.svelteProps = svelteProps;
  $rootScope.appContainerContentClass = appContainerContentClass;
};

ctrl.$inject = ['$scope','svelteComponent', 'svelteProps'];

tiz.controller('SveltePageCtrl', ctrl);